<template>
  <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal top" width="400px">
    <div class="text-box">
      <i class="iconfont icontishi"></i>
      {{ content }}
    </div>

    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      title: '',
      content: ''
    };
  },

  methods: {
    async open(data) {
      return new Promise((resolve, reject) => {
        this.title = data.title;
        this.content = data.content;
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.visible = false;
      this.reject();
    },
    ok() {
      this.visible = false;
      this.resolve();
    },
    resolve() {},
    reject() {}
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  &.top {
    /deep/ .ivu-modal {
      top: 15vh !important;
    }
  }
  /deep/ {
    .ivu-modal-body {
      font-size: 13px;
    }
    .ivu-modal-footer {
      .ivu-btn {
        width: 80px;
      }
    }
  }
  .text-box {
    padding: 20px 0;
    color: #515c6f;
    i {
      color: #f59853;
      font-size: 13px;
    }
  }
}
</style>
